import { render } from "./Console.vue?vue&type=template&id=327ed3b2&scoped=true"
import script from "./Console.vue?vue&type=script&lang=js"
export * from "./Console.vue?vue&type=script&lang=js"

import "./Console.vue?vue&type=style&index=0&id=327ed3b2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1095094746/src/dapp.nftea.studio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327ed3b2"]])

export default __exports__